import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetArtistProfileVideoListRequest } from '@/shared/api/requests/video/artist-video-list/request';
import { getArtistProfileVideoList } from '@/shared/api/requests/video/artist-video-list/request';

export const useArtistProfileVideoListQuery = (
  params: GetArtistProfileVideoListRequest,
  settings?: QuerySettings<typeof getArtistProfileVideoList>
) =>
  useQuery({
    queryKey: ['ArtistProfileVideoList', params.profileId],
    queryFn: () =>
      getArtistProfileVideoList({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
